import { TenantEntity } from '../TenantEntity'
import { saveAfrAddress } from '@/api/booking/afrAddress'

export class AfrAddress extends TenantEntity {
  /**
   * @param {Object} data
   */
  constructor(data) {
    super(data)
  }
  get state() {
    return this._data.state
  }
  set state(state) {
    this._data.state = state || 0
  }
  get docType() {
    return this._data.docType
  }
  set docType(docType) {
    this._data.docType = docType
  }
  get consolidationClosed() {
    return this._data.consolidationClosed
  }
  set consolidationClosed(consolidationClosed) {
    this._data.consolidationClosed = consolidationClosed || 0
  }
  get shipperCode() {
    return this._data.shipperCode
  }
  set shipperCode(shipperCode) {
    this._data.shipperCode = shipperCode
  }
  get shipperLine1() {
    return this._data.shipperLine1
  }
  set shipperLine1(shipperLine1) {
    this._data.shipperLine1 = shipperLine1
  }
  get shipperLine2() {
    return this._data.shipperLine2
  }
  set shipperLine2(shipperLine2) {
    this._data.shipperLine2 = shipperLine2
  }
  get shipperLine3() {
    return this._data.shipperLine3
  }
  set shipperLine3(shipperLine3) {
    this._data.shipperLine3 = shipperLine3
  }
  get shipperLine4() {
    return this._data.shipperLine4
  }
  set shipperLine4(shipperLine4) {
    this._data.shipperLine4 = shipperLine4
  }
  get shipperLine5() {
    return this._data.shipperLine5
  }
  set shipperLine5(shipperLine5) {
    this._data.shipperLine5 = shipperLine5
  }
  get shipperLine6() {
    return this._data.shipperLine6
  }
  set shipperLine6(shipperLine6) {
    this._data.shipperLine6 = shipperLine6
  }
  get shipperTel() {
    return this._data.shipperTel
  }
  set shipperTel(shipperTel) {
    this._data.shipperTel = shipperTel
  }
  get shipperFax() {
    return this._data.shipperFax
  }
  set shipperFax(shipperFax) {
    this._data.shipperFax = shipperFax
  }
  get shipperCity() {
    return this._data.shipperCity
  }
  set shipperCity(shipperCity) {
    this._data.shipperCity = shipperCity
  }
  get shipperProvince() {
    return this._data.shipperProvince
  }
  set shipperProvince(shipperProvince) {
    this._data.shipperProvince = shipperProvince
  }
  get shipperCountry() {
    return this._data.shipperCountry
  }
  set shipperCountry(shipperCountry) {
    this._data.shipperCountry = shipperCountry
  }
  get shipperPostalcode() {
    return this._data.shipperPostalcode
  }
  set shipperPostalcode(shipperPostalcode) {
    this._data.shipperPostalcode = shipperPostalcode
  }
  get consigneeCode() {
    return this._data.consigneeCode
  }
  set consigneeCode(consigneeCode) {
    this._data.consigneeCode = consigneeCode
  }
  get consigneeLine1() {
    return this._data.consigneeLine1
  }
  set consigneeLine1(consigneeLine1) {
    this._data.consigneeLine1 = consigneeLine1
  }
  get consigneeLine2() {
    return this._data.consigneeLine2
  }
  set consigneeLine2(consigneeLine2) {
    this._data.consigneeLine2 = consigneeLine2
  }
  get consigneeLine3() {
    return this._data.consigneeLine3
  }
  set consigneeLine3(consigneeLine3) {
    this._data.consigneeLine3 = consigneeLine3
  }
  get consigneeLine4() {
    return this._data.consigneeLine4
  }
  set consigneeLine4(consigneeLine4) {
    this._data.consigneeLine4 = consigneeLine4
  }
  get consigneeLine5() {
    return this._data.consigneeLine5
  }
  set consigneeLine5(consigneeLine5) {
    this._data.consigneeLine5 = consigneeLine5
  }
  get consigneeLine6() {
    return this._data.consigneeLine6
  }
  set consigneeLine6(consigneeLine6) {
    this._data.consigneeLine6 = consigneeLine6
  }
  get consigneeTel() {
    return this._data.consigneeTel
  }
  set consigneeTel(consigneeTel) {
    this._data.consigneeTel = consigneeTel
  }
  get consigneeFax() {
    return this._data.consigneeFax
  }
  set consigneeFax(consigneeFax) {
    this._data.consigneeFax = consigneeFax
  }
  get consigneeCity() {
    return this._data.consigneeCity
  }
  set consigneeCity(consigneeCity) {
    this._data.consigneeCity = consigneeCity
  }
  get consigneeProvince() {
    return this._data.consigneeProvince
  }
  set consigneeProvince(consigneeProvince) {
    this._data.consigneeProvince = consigneeProvince
  }
  get consigneeCountry() {
    return this._data.consigneeCountry
  }
  set consigneeCountry(consigneeCountry) {
    this._data.consigneeCountry = consigneeCountry
  }
  get consigneePostalcode() {
    return this._data.consigneePostalcode
  }
  set consigneePostalcode(consigneePostalcode) {
    this._data.consigneePostalcode = consigneePostalcode
  }
  get notifyCode() {
    return this._data.notifyCode
  }
  set notifyCode(notifyCode) {
    this._data.notifyCode = notifyCode
  }
  get notifyLine1() {
    return this._data.notifyLine1
  }
  set notifyLine1(notifyLine1) {
    this._data.notifyLine1 = notifyLine1
  }
  get notifyLine2() {
    return this._data.notifyLine2
  }
  set notifyLine2(notifyLine2) {
    this._data.notifyLine2 = notifyLine2
  }
  get notifyLine3() {
    return this._data.notifyLine3
  }
  set notifyLine3(notifyLine3) {
    this._data.notifyLine3 = notifyLine3
  }
  get notifyLine4() {
    return this._data.notifyLine4
  }
  set notifyLine4(notifyLine4) {
    this._data.notifyLine4 = notifyLine4
  }
  get notifyLine5() {
    return this._data.notifyLine5
  }
  set notifyLine5(notifyLine5) {
    this._data.notifyLine5 = notifyLine5
  }
  get notifyLine6() {
    return this._data.notifyLine6
  }
  set notifyLine6(notifyLine6) {
    this._data.notifyLine6 = notifyLine6
  }
  get notifyTel() {
    return this._data.notifyTel
  }
  set notifyTel(notifyTel) {
    this._data.notifyTel = notifyTel
  }
  get notifyFax() {
    return this._data.notifyFax
  }
  set notifyFax(notifyFax) {
    this._data.notifyFax = notifyFax
  }
  get notifyCity() {
    return this._data.notifyCity
  }
  set notifyCity(notifyCity) {
    this._data.notifyCity = notifyCity
  }
  get notifyProvince() {
    return this._data.notifyProvince
  }
  set notifyProvince(notifyProvince) {
    this._data.notifyProvince = notifyProvince
  }
  get notifyCountry() {
    return this._data.notifyCountry
  }
  set notifyCountry(notifyCountry) {
    this._data.notifyCountry = notifyCountry
  }
  get notifyPostalcode() {
    return this._data.notifyPostalcode
  }
  set notifyPostalcode(notifyPostalcode) {
    this._data.notifyPostalcode = notifyPostalcode
  }
  get alsonotifyCode() {
    return this._data.alsonotifyCode
  }
  set alsonotifyCode(alsonotifyCode) {
    this._data.alsonotifyCode = alsonotifyCode
  }
  get alsonotifyLine1() {
    return this._data.alsonotifyLine1
  }
  set alsonotifyLine1(alsonotifyLine1) {
    this._data.alsonotifyLine1 = alsonotifyLine1
  }
  get alsonotifyLine2() {
    return this._data.alsonotifyLine2
  }
  set alsonotifyLine2(alsonotifyLine2) {
    this._data.alsonotifyLine2 = alsonotifyLine2
  }
  get alsonotifyLine3() {
    return this._data.alsonotifyLine3
  }
  set alsonotifyLine3(alsonotifyLine3) {
    this._data.alsonotifyLine3 = alsonotifyLine3
  }
  get alsonotifyLine4() {
    return this._data.alsonotifyLine4
  }
  set alsonotifyLine4(alsonotifyLine4) {
    this._data.alsonotifyLine4 = alsonotifyLine4
  }
  get alsonotifyLine5() {
    return this._data.alsonotifyLine5
  }
  set alsonotifyLine5(alsonotifyLine5) {
    this._data.alsonotifyLine5 = alsonotifyLine5
  }
  get alsonotifyLine6() {
    return this._data.alsonotifyLine6
  }
  set alsonotifyLine6(alsonotifyLine6) {
    this._data.alsonotifyLine6 = alsonotifyLine6
  }
  get alsonotifyTel() {
    return this._data.alsonotifyTel
  }
  set alsonotifyTel(alsonotifyTel) {
    this._data.alsonotifyTel = alsonotifyTel
  }
  get alsonotifyFax() {
    return this._data.alsonotifyFax
  }
  set alsonotifyFax(alsonotifyFax) {
    this._data.alsonotifyFax = alsonotifyFax
  }
  get alsonotifyCity() {
    return this._data.alsonotifyCity
  }
  set alsonotifyCity(alsonotifyCity) {
    this._data.alsonotifyCity = alsonotifyCity
  }
  get alsonotifyProvince() {
    return this._data.alsonotifyProvince
  }
  set alsonotifyProvince(alsonotifyProvince) {
    this._data.alsonotifyProvince = alsonotifyProvince
  }
  get alsonotifyCountry() {
    return this._data.alsonotifyCountry
  }
  set alsonotifyCountry(alsonotifyCountry) {
    this._data.alsonotifyCountry = alsonotifyCountry
  }
  get alsonotifyPostalcode() {
    return this._data.alsonotifyPostalcode
  }
  set alsonotifyPostalcode(alsonotifyPostalcode) {
    this._data.alsonotifyPostalcode = alsonotifyPostalcode
  }
  get cargoDocUuid() {
    return this._data.cargoDocUuid
  }
  set cargoDocUuid(cargoDocUuid) {
    this._data.cargoDocUuid = cargoDocUuid
  }
  get shipperContactName() {
    return this._data.shipperContactName
  }
  set shipperContactName(shipperContactName) {
    this._data.shipperContactName = shipperContactName
  }

  get shipperTypeOfPerson() {
    return this._data.shipperTypeOfPerson
  }
  set shipperTypeOfPerson(shipperTypeOfPerson) {
    this._data.shipperTypeOfPerson = shipperTypeOfPerson
  }

  get shipperEmail() {
    return this._data.shipperEmail
  }
  set shipperEmail(shipperEmail) {
    this._data.shipperEmail = shipperEmail
  }

  get shipperStreetNo() {
    return this._data.shipperStreetNo
  }
  set shipperStreetNo(shipperStreetNo) {
    this._data.shipperStreetNo = shipperStreetNo
  }

  get shipperEori() {
    return this._data.shipperEori
  }
  set shipperEori(shipperEori) {
    this._data.shipperEori = shipperEori
  }
  get consigneeContactName() {
    return this._data.consigneeContactName
  }
  set consigneeContactName(consigneeContactName) {
    this._data.consigneeContactName = consigneeContactName
  }

  get consigneeTypeOfPerson() {
    return this._data.consigneeTypeOfPerson
  }
  set consigneeTypeOfPerson(consigneeTypeOfPerson) {
    this._data.consigneeTypeOfPerson = consigneeTypeOfPerson
  }

  get consigneeEmail() {
    return this._data.consigneeEmail
  }
  set consigneeEmail(consigneeEmail) {
    this._data.consigneeEmail = consigneeEmail
  }

  get consigneeStreetNo() {
    return this._data.consigneeStreetNo
  }
  set consigneeStreetNo(consigneeStreetNo) {
    this._data.consigneeStreetNo = consigneeStreetNo
  }

  get consigneeEori() {
    return this._data.consigneeEori
  }
  set consigneeEori(consigneeEori) {
    this._data.consigneeEori = consigneeEori
  }
  get notifyContactName() {
    return this._data.notifyContactName
  }
  set notifyContactName(notifyContactName) {
    this._data.notifyContactName = notifyContactName
  }

  get notifyTypeOfPerson() {
    return this._data.notifyTypeOfPerson
  }
  set notifyTypeOfPerson(notifyTypeOfPerson) {
    this._data.notifyTypeOfPerson = notifyTypeOfPerson
  }

  get notifyEmail() {
    return this._data.notifyEmail
  }
  set notifyEmail(notifyEmail) {
    this._data.notifyEmail = notifyEmail
  }

  get notifyStreetNo() {
    return this._data.notifyStreetNo
  }
  set notifyStreetNo(notifyStreetNo) {
    this._data.notifyStreetNo = notifyStreetNo
  }

  get notifyEori() {
    return this._data.notifyEori
  }
  set notifyEori(notifyEori) {
    this._data.notifyEori = notifyEori
  }

  get sellerName() {
    return this._data.sellerName
  }
  set sellerName(sellerName) {
    this._data.sellerName = sellerName
  }

  get sellerAddress1() {
    return this._data.sellerAddress1
  }
  set sellerAddress1(sellerAddress1) {
    this._data.sellerAddress1 = sellerAddress1
  }

  get sellerAddress2() {
    return this._data.sellerAddress2
  }
  set sellerAddress2(sellerAddress2) {
    this._data.sellerAddress2 = sellerAddress2
  }

  get sellerStreetNo() {
    return this._data.sellerStreetNo
  }
  set sellerStreetNo(sellerStreetNo) {
    this._data.sellerStreetNo = sellerStreetNo
  }

  get sellerCountry() {
    return this._data.sellerCountry
  }
  set sellerCountry(sellerCountry) {
    this._data.sellerCountry = sellerCountry
  }

  get sellerCity() {
    return this._data.sellerCity
  }
  set sellerCity(sellerCity) {
    this._data.sellerCity = sellerCity
  }

  get sellerPostalcode() {
    return this._data.sellerPostalcode
  }
  set sellerPostalcode(sellerPostalcode) {
    this._data.sellerPostalcode = sellerPostalcode
  }

  get sellerProvince() {
    return this._data.sellerProvince
  }
  set sellerProvince(sellerProvince) {
    this._data.sellerProvince = sellerProvince
  }

  get sellerTel() {
    return this._data.sellerTel
  }
  set sellerTel(sellerTel) {
    this._data.sellerTel = sellerTel
  }

  get sellerEmail() {
    return this._data.sellerEmail
  }
  set sellerEmail(sellerEmail) {
    this._data.sellerEmail = sellerEmail
  }

  get sellerTypeOfPerson() {
    return this._data.sellerTypeOfPerson
  }
  set sellerTypeOfPerson(sellerTypeOfPerson) {
    this._data.sellerTypeOfPerson = sellerTypeOfPerson
  }

  get sellerContactName() {
    return this._data.sellerContactName
  }
  set sellerContactName(sellerContactName) {
    this._data.sellerContactName = sellerContactName
  }

  get sellerEori() {
    return this._data.sellerEori
  }
  set sellerEori(sellerEori) {
    this._data.sellerEori = sellerEori
  }
  get buyerName() {
    return this._data.buyerName
  }
  set buyerName(buyerName) {
    this._data.buyerName = buyerName
  }

  get buyerAddress1() {
    return this._data.buyerAddress1
  }
  set buyerAddress1(buyerAddress1) {
    this._data.buyerAddress1 = buyerAddress1
  }

  get buyerAddress2() {
    return this._data.buyerAddress2
  }
  set buyerAddress2(buyerAddress2) {
    this._data.buyerAddress2 = buyerAddress2
  }

  get buyerStreetNo() {
    return this._data.buyerStreetNo
  }
  set buyerStreetNo(buyerStreetNo) {
    this._data.buyerStreetNo = buyerStreetNo
  }

  get buyerCountry() {
    return this._data.buyerCountry
  }
  set buyerCountry(buyerCountry) {
    this._data.buyerCountry = buyerCountry
  }

  get buyerCity() {
    return this._data.buyerCity
  }
  set buyerCity(buyerCity) {
    this._data.buyerCity = buyerCity
  }

  get buyerPostalcode() {
    return this._data.buyerPostalcode
  }
  set buyerPostalcode(buyerPostalcode) {
    this._data.buyerPostalcode = buyerPostalcode
  }

  get buyerProvince() {
    return this._data.buyerProvince
  }
  set buyerProvince(buyerProvince) {
    this._data.buyerProvince = buyerProvince
  }

  get buyerTel() {
    return this._data.buyerTel
  }
  set buyerTel(buyerTel) {
    this._data.buyerTel = buyerTel
  }

  get buyerEmail() {
    return this._data.buyerEmail
  }
  set buyerEmail(buyerEmail) {
    this._data.buyerEmail = buyerEmail
  }

  get buyerTypeOfPerson() {
    return this._data.buyerTypeOfPerson
  }
  set buyerTypeOfPerson(buyerTypeOfPerson) {
    this._data.buyerTypeOfPerson = buyerTypeOfPerson
  }

  get buyerContactName() {
    return this._data.buyerContactName
  }
  set buyerContactName(buyerContactName) {
    this._data.buyerContactName = buyerContactName
  }

  get buyerEori() {
    return this._data.buyerEori
  }
  set buyerEori(buyerEori) {
    this._data.buyerEori = buyerEori
  }
  get carrierName() {
    return this._data.carrierName
  }
  set carrierName(carrierName) {
    this._data.carrierName = carrierName
  }

  get carrierAddress1() {
    return this._data.carrierAddress1
  }
  set carrierAddress1(carrierAddress1) {
    this._data.carrierAddress1 = carrierAddress1
  }

  get carrierAddress2() {
    return this._data.carrierAddress2
  }
  set carrierAddress2(carrierAddress2) {
    this._data.carrierAddress2 = carrierAddress2
  }

  get carrierStreetNo() {
    return this._data.carrierStreetNo
  }
  set carrierStreetNo(carrierStreetNo) {
    this._data.carrierStreetNo = carrierStreetNo
  }

  get carrierCountry() {
    return this._data.carrierCountry
  }
  set carrierCountry(carrierCountry) {
    this._data.carrierCountry = carrierCountry
  }

  get carrierCity() {
    return this._data.carrierCity
  }
  set carrierCity(carrierCity) {
    this._data.carrierCity = carrierCity
  }

  get carrierPostalcode() {
    return this._data.carrierPostalcode
  }
  set carrierPostalcode(carrierPostalcode) {
    this._data.carrierPostalcode = carrierPostalcode
  }

  get carrierProvince() {
    return this._data.carrierProvince
  }
  set carrierProvince(carrierProvince) {
    this._data.carrierProvince = carrierProvince
  }

  get carrierTel() {
    return this._data.carrierTel
  }
  set carrierTel(carrierTel) {
    this._data.carrierTel = carrierTel
  }

  get carrierEmail() {
    return this._data.carrierEmail
  }
  set carrierEmail(carrierEmail) {
    this._data.carrierEmail = carrierEmail
  }

  get carrierTypeOfPerson() {
    return this._data.carrierTypeOfPerson
  }
  set carrierTypeOfPerson(carrierTypeOfPerson) {
    this._data.carrierTypeOfPerson = carrierTypeOfPerson
  }

  get carrierContactName() {
    return this._data.carrierContactName
  }
  set carrierContactName(carrierContactName) {
    this._data.carrierContactName = carrierContactName
  }

  get carrierEori() {
    return this._data.carrierEori
  }
  set carrierEori(carrierEori) {
    this._data.carrierEori = carrierEori
  }
  get representativeName() {
    return this._data.representativeName
  }
  set representativeName(representativeName) {
    this._data.representativeName = representativeName
  }

  get representativeAddress1() {
    return this._data.representativeAddress1
  }
  set representativeAddress1(representativeAddress1) {
    this._data.representativeAddress1 = representativeAddress1
  }

  get representativeAddress2() {
    return this._data.representativeAddress2
  }
  set representativeAddress2(representativeAddress2) {
    this._data.representativeAddress2 = representativeAddress2
  }

  get representativeStreetNo() {
    return this._data.representativeStreetNo
  }
  set representativeStreetNo(representativeStreetNo) {
    this._data.representativeStreetNo = representativeStreetNo
  }

  get representativeCountry() {
    return this._data.representativeCountry
  }
  set representativeCountry(representativeCountry) {
    this._data.representativeCountry = representativeCountry
  }

  get representativeCity() {
    return this._data.representativeCity
  }
  set representativeCity(representativeCity) {
    this._data.representativeCity = representativeCity
  }

  get representativePostalcode() {
    return this._data.representativePostalcode
  }
  set representativePostalcode(representativePostalcode) {
    this._data.representativePostalcode = representativePostalcode
  }

  get representativeProvince() {
    return this._data.representativeProvince
  }
  set representativeProvince(representativeProvince) {
    this._data.representativeProvince = representativeProvince
  }

  get representativeTel() {
    return this._data.representativeTel
  }
  set representativeTel(representativeTel) {
    this._data.representativeTel = representativeTel
  }

  get representativeEmail() {
    return this._data.representativeEmail
  }
  set representativeEmail(representativeEmail) {
    this._data.representativeEmail = representativeEmail
  }

  get representativeTypeOfPerson() {
    return this._data.representativeTypeOfPerson
  }
  set representativeTypeOfPerson(representativeTypeOfPerson) {
    this._data.representativeTypeOfPerson = representativeTypeOfPerson
  }

  get representativeContactName() {
    return this._data.representativeContactName
  }
  set representativeContactName(representativeContactName) {
    this._data.representativeContactName = representativeContactName
  }

  get representativeEori() {
    return this._data.representativeEori
  }
  set representativeEori(representativeEori) {
    this._data.representativeEori = representativeEori
  }
  get copyToSeller() {
    return this._data.copyToSeller
  }
  set copyToSeller(copyToSeller) {
    this._data.copyToSeller = copyToSeller
  }
  get copyToBuyer() {
    return this._data.copyToBuyer
  }
  set copyToBuyer(copyToBuyer) {
    this._data.copyToBuyer = copyToBuyer
  }
  static async save(data) {
    return await saveAfrAddress(data).then(res => res.data)
  }
}
